//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavBar from '@/components/NavBar.vue';
import CommonFooter from '@/components/CommonFooter.vue';
import TitleBox from '@/components/TitleBox.vue';
import CustomDialog from '@/components/CustomDialog.vue';
import VideoWrapper from '@/components/VideoWrapper.vue';
import ScrollTop from '@/components/ScrollTop.vue';
export default {
    components: {
        NavBar,
        CommonFooter,
        TitleBox,
        CustomDialog,
        VideoWrapper,
        ScrollTop
    },
    beforeRouteEnter(to, from, next) {
        const obj = {
            introduction: 0,
            guide: 1,
            customs: 2,
            video: 3
        };
        const params = to.params;
        if (params.anchor && !params.id) {
            next((vm) => {
                vm.currentItem = obj[params.anchor];
            });
            return;
        }
        if (params.anchor && params.id) {
            var propName = '';
            if (params.anchor === 'guide') {
                propName = 'defGuide';
            }
            if (params.anchor === 'video') {
                propName = 'defVideo';
            }
            next((vm) => {
                vm[propName] = params.id;
                vm.currentItem = obj[params.anchor];
            });
            return;
        }
        next((vm) => {
            vm.currentItem = 0;
        });
    },
    beforeRouteUpdate(to, from) {
        const obj = {
            introduction: 0,
            guide: 1,
            customs: 2,
            video: 3
        };
        this.currentItem = obj[to.query.anchor];
    },
    data() {
        return {
            currentItem: 0,
            typeList: [],
            introduction: '',
            guideList: [],
            guideDetail: '',
            videoList: [],
            videoDetail: '',
            custom: '',
            show: {
                vr: false
            },
            banner: '',
            activeSlide: ''
        };
    },
    watch: {
        currentItem() {
            this.scrollTop();
            if (this.currentItem === 1) {
                this.getGuideList().then(() => {
                    this.initSwiper('#guide');
                    this.getGuideDetail(this.defGuide || this.guideList[0].id);
                });
            }
            if (this.currentItem === 3) {
                this.getVideoList().then(() => {
                    this.initSwiper('#video');
                    this.getVideoDetail(this.defVideo || this.videoList[0].id);
                });
            }
        },
        i18n() {
            if (this.currentItem === 1) {
                this.getGuideList().then(() => {
                    this.initSwiper('#guide');
                    this.getGuideDetail(this.defGuide || this.guideList[0].id);
                });
            }
            if (this.currentItem === 3) {
                this.getVideoList().then(() => {
                    this.initSwiper('#video');
                    this.getVideoDetail(this.defVideo || this.videoList[0].id);
                });
            }
        }
    },
    mounted() {
        this.getTypes();
        this.getIntro();
        this.getCustom();
    },
    methods: {
        initSwiper(selector) {
            new window.Swiper(selector, {
                // 循环模式选项
                loop: false, // 循环下，vue监听事件会有问题
                /* autoplay: {
                    disableOnInteraction: false
                }, */
                effect: 'coverflow',
                slidesPerView: 'auto',
                centeredSlides: false,
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 0,
                    modifier: 0,
                    slideShadows: false
                },
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: selector + ' .swiper-button-next',
                    prevEl: selector + ' .swiper-button-prev'
                }
            });
        },
        getTypes() {
            this.axios({
                method: 'post',
                url: '/articleCategory/list',
                data: {
                    pid: 1
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.typeList = res.data;
                }
            });
        },
        getIntro() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '7'
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.introduction = res.data.content;
                }
            });
        },
        getGuideList() {
            return this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '8',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.guideList = res.data.data;
                }
            });
        },
        getGuideDetail(id) {
            this.axios({
                method: 'post',
                url: '/article/detail',
                data: {
                    id
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.activeSlide = id;
                    this.guideDetail = res.data;
                }
            });
        },
        getVideoList() {
            return this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '28',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.videoList = res.data.data;
                }
            });
        },
        getVideoDetail(id) {
            console.log('id: ', id);
            this.axios({
                method: 'post',
                url: '/article/detail',
                data: {
                    id
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.activeSlide = id;
                    this.videoDetail = res.data;
                }
            });
        },
        getCustom() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '9'
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.custom = res.data.content;
                }
            });
        }
    }
};
